/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AllSchedulePPD = {
    properties: {
        company: {
    type: 'PPDDetail',
    isRequired: true,
},
        departments: {
    type: 'array',
    contains: {
        type: 'DepartmentSchedulePPD',
    },
    isRequired: true,
},
    },
};